import type { Catalog } from "./fr.ts";

/** Catálogo en español — tipado contra la fuente de verdad francesa. */
const es: Record<keyof Catalog, string> = {
  "brand.aria": "Mondial 2026 — inicio",
  "brand.hosts": "Países anfitriones: Estados Unidos · Canadá · México",
  "mode.aria": "Modo de visualización",
  "mode.dashboard": "Panel",
  "mode.projection": "Proyección",
  "mode.sim": "Simulación",
  "mode.stats": "Estadísticas",
  "mode.method": "Método",
  "mode.method.aria": "Cómo se calculan las estadísticas",
  replay: "Repetir",
  "replay.title": "Repetir los resultados hasta ahora",
  "theme.aria": "Cambiar entre modo claro y oscuro",
  "theme.title": "Claro / oscuro",
  "refresh.title": "Actualizar ahora",
  "lang.aria": "Idioma",
  "rotate.hint": "Gira el teléfono a vertical para una mejor experiencia",
  "rotate.dismiss": "Descartar",
  "fresh.connecting": "conectando a los datos…",
  "fresh.unavailable": "datos no disponibles",
  "fresh.up": "al día",
  "fresh.late": "con retraso",
  "fresh.offline": "sin conexión",
  "fresh.state": "Datos: {state}",
  "banner.cached": "Datos del {date} — actualización no disponible",
  "banner.degraded": "Datos en vivo no disponibles — mostrando el calendario base",
  "foot.source": "Fuente en vivo",
  "foot.dataFrom": "datos del {date}",
  "foot.lastCalc": "Último cálculo",
  "foot.tz": "Horarios en tu zona horaria",
  "foot.disclaimer":
    "Modelo estadístico informativo — no es un pronóstico garantizado. Banderas: flag-icons (jsDelivr).",
  "ago.s": "hace {n} s",
  "ago.min": "hace {n} min",
  "ago.h": "hace {n} h",
  "cd.imminent": "inminente",
  "cd.waiting": "esperando el directo",
  "cd.days": "en {d}d {h}h",
  "cd.hours": "en {h}h {m}min",
  "cd.mins": "en {m}min {s}s",
  "cd.secs": "en {s}s",
  today: "Hoy",
  "today.short": "Hoy",
  "today.scrollAria": "Partidos (desplazamiento horizontal)",
  "today.untilTomorrow": "hasta mañana 9h",
  "today.match.one": "{n} partido",
  "today.match.other": "{n} partidos",
  "today.noMatch": "ningún partido",
  "today.none": "Ningún partido ese día.",
  "today.choose": "Elegir un día",
  "lf.stats": "Estadísticas",
  "lf.lineups": "Alineaciones",
  "lf.lineupsNone": "Alineaciones no comunicadas",
  "round.group": "Fase de grupos",
  "round.r32": "Dieciseisavos de final",
  "round.r16": "Octavos de final",
  "round.qf": "Cuartos de final",
  "round.sf": "Semifinal",
  "round.third": "Partido por el tercer puesto",
  "round.final": "Final",
  // --- i18n sweep 28/06 : chaînes auparavant codées en dur (composants/fiches) ---
  "bracket.final": "FINAL",
  "bracket.round.qfShort": "Cuartos",
  "bracket.round.sfShort": "Semis",
  "bracket.thirdPlace": "3.º PUESTO",
  "bracket.title": "Cuadro final",
  "clubs.col.assists": "Asistencias",
  "clubs.col.assists.title": "Ordenar por asistencias acumuladas",
  "clubs.col.avgRating": "Nota media",
  "clubs.col.avgRating.title": "Ordenar por nota media (haz clic en una 2ª columna para desempatar)",
  "clubs.col.club": "Club",
  "clubs.col.goals.title": "Ordenar por goles acumulados de los jugadores del club",
  "clubs.col.players.title": "Ordenar por número de jugadores con nota",
  "clubs.note": "Para cada club, tomamos sus jugadores presentes en el Mundial: la NOTA es la media de su nota del torneo (cada jugador cuenta una vez); GOLES y ASISTENCIAS son sus totales acumulados en la Copa del Mundo. Solo se clasifican los clubes con al menos 3 jugadores con nota. Haz clic en un encabezado para ordenar — una 2ª columna sirve de desempate (¹ primaria, ² secundaria). Pasa el cursor sobre una fila para ver sus mejores contribuidores.",
  "clubs.row.title": "{name} — detalle por jugador · {tip}",
  "clubs.section.count": "nota media de sus internacionales en la Copa del Mundo",
  "clubs.section.title": "Clubes en el Mundial",
  "common.absent": "Ausente",
  "common.asOf": "al",
  "common.assists": "asistencias",
  "common.assists.v2": "asistencias",
  "common.avgAbbr": "med",
  "common.champion": "campeón",
  "common.close": "Cerrar",
  "common.draw": "empate",
  "common.dribbles": "regates",
  "common.duels": "duelos",
  "common.eliminated": "eliminado",
  "common.finished": "FINALIZADO",
  "common.goals": "goles",
  "common.halfTime": "Descanso",
  "common.halfTimeAbbr": "DESC",
  "common.keyPasses": "pases clave",
  "common.live": "EN VIVO",
  "common.loading": "cargando…",
  "common.loading.v2": "Cargando…",
  "common.match": "partido",
  "common.matchesAbbr": "part.",
  "common.ordinal.first": "º",
  "common.ordinal.other": "º",
  "common.ordinal.suffix": "º",
  "common.penaltiesAbbr": "PEN",
  "common.penaltiesAbbr.v2": "pen",
  "common.player": "jugador",
  "common.players": "jugadores",
  "common.points": "puntos",
  "common.pos.attackers": "Delanteros",
  "common.pos.defenders": "Defensas",
  "common.pos.midfielders": "Centrocampistas",
  "common.pos.others": "Otros",
  "common.postponed": "aplazado",
  "common.rated": "con nota",
  "common.suspended": "Suspendido",
  "common.tackles": "entradas",
  "common.top": "top",
  "common.upcoming": "Próximos",
  "common.vs": "vs",
  "common.winAbbr": "V",
  "common.yearsOld": "años",
  "elo.adjusted.title": "valoración ajustada (bajas declaradas)",
  "elo.avg.row": "Media del torneo",
  "elo.col.sort.title": "Ordenar por {label} (haz clic en una 2ª columna para desempatar)",
  "elo.col.value": "Valor",
  "elo.delta.title": "variación desde el 11/06",
  "elo.note": "Fórmula World Football Elo Ratings (K = 60) · {n} equipo ya movido · Δ desde antes del torneo · Nota = nota media del equipo en el torneo · valor de plantilla (Transfermarkt) · haz clic en un encabezado para ordenar — una 2ª columna sirve de desempate (¹ primaria, ² secundaria); una Nota o un Valor abre el detalle jugador por jugador · * valoración ajustada.",
  "elo.note.btn.title": "Detalle por jugador — nota media de competición (sobre {n} partido con nota)",
  "elo.section.count": "en vivo · recalculado al final de cada partido",
  "elo.section.title": "Clasificación Elo",
  "elo.value.btn.title": "Detalle jugador por jugador + fuente del valor",
  "elo.value.millions": "{n} M€",
  "fiche.closeDetail": "Cerrar el detalle",
  "fiche.closeProfile": "Cerrar ficha",
  "fiche.country.attack.fair": "acorde con su xG",
  "fiche.country.attack.for": "para",
  "fiche.country.attack.over": "marca más que su xG",
  "fiche.country.attack.subtitle": "goles vs xG",
  "fiche.country.attack.title": "Eficacia ofensiva",
  "fiche.country.attack.under": "marca menos que su xG",
  "fiche.country.conversionWord": "conversión",
  "fiche.country.defense.bad": "encaja más que el xG rival",
  "fiche.country.defense.concededWord": "encajado",
  "fiche.country.defense.fair": "acorde con el xG rival",
  "fiche.country.defense.good": "encaja menos que el xG rival",
  "fiche.country.defense.oppXg": "xG rival",
  "fiche.country.defense.prevented": "evitados",
  "fiche.country.defense.subtitle": "goles encajados vs xG rival",
  "fiche.country.defense.title": "Solidez defensiva",
  "fiche.country.dialogLabel": "Ficha del país",
  "fiche.country.lowSample": "pocos partidos, por confirmar",
  "fiche.country.over": "en",
  "fiche.country.rendement": "Rendimiento:",
  "fiche.country.rendement.value": "valor",
  "fiche.country.results": "Resultados",
  "fiche.country.squad.title": "Plantilla",
  "fiche.country.squad.unavailable": "Plantilla no disponible (se carga desde el archivo en producción).",
  "fiche.country.tile.rank": "posición",
  "fiche.country.tile.squadValue": "valor plantilla",
  "fiche.country.value.fair": "a la altura de su valor",
  "fiche.country.value.over": "por encima de su valor",
  "fiche.country.value.under": "por debajo de su valor",
  "fiche.country.xgDiff.conceded": "concedidos",
  "fiche.country.xgDiff.created": "creados",
  "fiche.country.xgDiff.title": "Diferencial de xG",
  "fiche.deserved.cell": "{xg} xG → {goals}",
  "fiche.deservedTitle": "Resultado merecido (xG)",
  "fiche.dominance": "Dominio",
  "fiche.eventsLive": "Eventos en vivo",
  "fiche.eventsMatch": "Eventos del partido",
  "fiche.expectedGoalsModel": "Goles esperados (modelo)",
  "fiche.h2h.draws": "{d} empate",
  "fiche.h2h.empty": "Sin enfrentamientos registrados",
  "fiche.h2h.meetings": "{n} enfrentamiento",
  "fiche.h2h.title": "Cara a cara",
  "fiche.h2h.winsTitle": "{w} victoria",
  "fiche.htScore": "DESC {h}–{a}",
  "fiche.overlayAria": "Detalle del partido",
  "fiche.player.age": "{age} años",
  "fiche.player.apps": "partidos",
  "fiche.player.avgRating": "nota med.",
  "fiche.player.dialogLabel": "Ficha del jugador",
  "fiche.player.fallbackName": "Jugador",
  "fiche.player.lastMatch": "Último partido",
  "fiche.player.matchByMatch": "Partido a partido",
  "fiche.player.metrics.cumTournament": "acumulado del torneo",
  "fiche.player.metrics.profile": "perfil {pos}",
  "fiche.player.metrics.title": "Métricas",
  "fiche.player.metrics.vsPosAvg": "vs media de la posición",
  "fiche.player.noMatches": "Aún no hay partidos archivados para este jugador.",
  "fiche.player.noStats": "Sin estadísticas esta temporada",
  "fiche.player.pos.attacker": "Delantero",
  "fiche.player.pos.defender": "Defensa",
  "fiche.player.pos.goalkeeper": "Portero",
  "fiche.player.pos.midfielder": "Centrocampista",
  "fiche.player.ratingCurve.ariaLabel": "Evolución de las notas del jugador",
  "fiche.player.ratingCurve.title": "Evolución de las notas",
  "fiche.player.seasonAvg": "prom. temporada",
  "fiche.player.unavailable": "Ficha no disponible",
  "fiche.player.vsOpp": "vs {opp}",
  "fiche.player.vsPosAvg": "vs media de {pos} del torneo",
  "fiche.playerRatings.avgOn": "media sobre {n}",
  "fiche.playerRatings.avgOnRated": "media sobre {n} con nota",
  "fiche.playerRatings.dialogLabel": "Nota del equipo por jugador",
  "fiche.playerRatings.empty": "No hay notas de jugadores archivadas para este equipo (las notas aparecen una vez disputados los partidos).",
  "fiche.playerRatings.foot": "Nota media en los partidos del Mundial (notas por partido de API-Football) · ordenadas de mayor a menor · haz clic en un nombre para ver la curva partido a partido.",
  "fiche.playerRatings.subtitle": "Notas de la competición",
  "fiche.preMatch": "Previa",
  "fiche.probabilityDraw": "Probabilidad — empate {draw}",
  "fiche.recentForm": "Forma reciente",
  "fiche.squadValue.empty": "Detalle de jugadores no disponible para este equipo.",
  "fiche.squadValue.footClickSource": "Haz clic en {icon} para ver la fuente.",
  "fiche.squadValue.footPrefix": "Valores de Transfermarkt",
  "fiche.squadValue.footSum": "suma de los {n} jugadores más valiosos (entrada del modelo «Elo + valor»).",
  "fiche.squadValue.sourceTitle": "Fuente: Transfermarkt",
  "fiche.squadValue.subtitle": "Valor de la plantilla",
  "fiche.squadValue.viewOn": "Ver a {name} en Transfermarkt",
  "fiche.standing": "Clasificación",
  "fiche.statsLive": "Estadísticas en vivo",
  "fiche.statsMatch": "Estadísticas del partido",
  "fiche.teamRating.curve.ariaLabel": "Evolución de la nota del equipo partido a partido",
  "fiche.teamRating.curve.title": "Evolución de la nota del equipo",
  "fiche.teamRating.curve.trendTitle": "Tendencia en los últimos partidos",
  "fiche.teamRating.curveTrend.down": "a la baja",
  "fiche.teamRating.curveTrend.flat": "estable",
  "fiche.teamRating.curveTrend.up": "en alza",
  "fiche.teamRating.tagTitle": "Nota del equipo — media ponderada por minutos ({n} jugadores con nota)",
  "fiche.teamRating.trend.down": "forma a la baja",
  "fiche.teamRating.trend.flat": "forma estable",
  "fiche.teamRating.trend.up": "forma en alza",
  "fiche.teamRating.trendTitleSuffix": "(nota reciente del equipo)",
  "fiche.tournamentXi": "Once ideal del torneo",
  "groups.legend.direct": "clasificados directos",
  "groups.legend.live": "marcador en juego incluido",
  "groups.legend.thirds": "tercero en zona de repesca (puesto entre los terceros)",
  "groups.liveScoreTitle": "Marcador en juego incluido",
  "groups.playedCount": "{played}/6 PJ",
  "groups.provisionalTitle": "Clasificación provisional (partido en curso)",
  "groups.thirdRankBadge": "3.º&nbsp;#{n}",
  "groups.thirdRankTitle": "Puesto entre los terceros",
  "lb.apps": "{n} p",
  "lb.col.assists": "Asistencias",
  "lb.col.ratings": "Notas",
  "lb.col.scorers": "Goleadores",
  "lb.empty": "Ninguno por ahora",
  "lb.section.count": "desde el inicio del torneo",
  "lb.section.title": "Clasificaciones de jugadores",
  "lb.unit.assist.one": "asistencia",
  "lb.unit.goal.one": "gol",
  "lf.assistBy": "asistencia {player}",
  "lf.awaitingLiveData": "esperando datos en vivo",
  "lf.event.goal": "Gol",
  "lf.event.red": "Tarjeta roja",
  "lf.event.subst": "Sustitución",
  "lf.event.yellow": "Tarjeta amarilla",
  "lf.expandMiniTitle": "{home} – {away} — mostrar en grande (compartir el espacio)",
  "lf.expectedGoals": "Goles esperados",
  "lf.groupMatchday": "Grupo {group} · Jornada {matchday}",
  "lf.groupMatchdayAbbr": "Grupo {group} · J{matchday}",
  "lf.halfTimeScore": "Descanso {h}–{a}",
  "lf.inProgress": "en curso",
  "lf.kickoffAt": "Inicio {time}",
  "lf.kickoffPassed": "INICIO PASADO",
  "lf.kickoffShort": "Inicio",
  "lf.kickoffWaitingLive": "Inicio {kick} · esperando datos en vivo",
  "lf.kickoffYourLocalTime": "Inicio {kick} · su hora local",
  "lf.lineupsNotProvided": "Alineaciones no comunicadas",
  "lf.lineupsTitle": "Alineaciones",
  "lf.lineupsUpper": "ALINEACIONES",
  "lf.minimizeMatch": "Minimizar este partido en una mini-tarjeta",
  "lf.modelPrediction": "predicción del modelo",
  "lf.nextMatch": "PRÓXIMO PARTIDO",
  "lf.nextMiniAria": "Próximo partido — pasa el cursor o actívalo para la predicción previa",
  "lf.nextShort": "PRÓXIMO",
  "lf.opponentsUnknown": "Rivales aún no conocidos — predicción próximamente.",
  "lf.penaltiesScore": "PEN {h}–{a}",
  "lf.predictionDraw": "Predicción — empate {draw}",
  "lf.predictionDrawLabel": "Predicción — empate {pct}",
  "lf.strengthElo": "Fuerza (Elo)",
  "lf.yourLocalTime": "tu hora local",
  "lineup.absentUncertain": "ausente/dudoso",
  "lineup.captain": "capitán",
  "lineup.startingLineupsAria": "Alineaciones titulares",
  "lineup.substitutes": "Suplentes",
  "method.elo": "Valoraciones reales World Football Elo Ratings a 11/06/2026 (eloratings.net), actualizadas tras cada partido terminado (K = 60, ventaja de local +100, penaltis contados como empate). * Valoraciones ajustadas por bajas declaradas: NED −22, BRA −10, CAN −12.",
  "method.footer": "<b>Precauciones:</b> a escala de un Mundial (1 a 7 partidos), las desviaciones del xG se deben sobre todo al <b>azar</b> — estas métricas <b>describen</b> lo ocurrido, no <b>predicen</b>. Los umbrales entre paréntesis (≥ 3 tiros, ≥ 5 duelos, xG ≥ 3…) son salvaguardas: por debajo, la estadística se oculta o su veredicto no se colorea. El xG proviene de un solo modelo (API-Football).",
  "method.goals": "Goles esperados: mapeo Elo→Poisson del modelo original (continuidad v2), ventaja de local +90 en la predicción. Empate en fase eliminatoria: prórroga (λ×⅓) y luego penaltis según la calidad de los porteros (EA FC 26, {n}/48 equipos cubiertos, 50/50 en caso contrario — los estudios recientes no miden una ventaja sistemática).",
  "method.intro": "Cada cifra mostrada se <b>obtiene</b> de una fuente de datos o se <b>calcula</b> en la aplicación a partir de esos datos — nunca la genera una IA. Todo es <b>determinista</b> y reproducible. Leyenda de fuentes:",
  "method.legend.apiFootball": "<b>API-Football</b> — estadísticas de partido, equipo y jugador",
  "method.legend.appCalc": "<b>Cálculo de la app</b> — derivado de las estadísticas brutas (fórmulas abajo)",
  "method.legend.otherFeeds": "<b>Otros flujos</b> — Transfermarkt (valor), eloratings (Elo), FIFA (clasificación oficial)",
  "method.legend.simulation": "<b>Simulación</b> — Monte-Carlo Elo–Poisson (con semilla, reproducible)",
  "method.row.bestThirds.d": "los 8 repescados: pts → dif → goles → clasificación FIFA → sorteo. Tiempo real (⏱)",
  "method.row.bestThirds.s": "Mejores terceros",
  "method.row.bestThirds.w": "sección dedicada",
  "method.row.bestXiClubs.d": "mejor XI por nota; nota media agrupada por club",
  "method.row.bestXiClubs.s": "Once ideal · Notas por club",
  "method.row.bestXiClubs.w": "«Clasificaciones», sección de clubes",
  "method.row.citiesByPlace.d": "la posición de grupo fija el hueco de R32 → todo el recorrido / estadios se derivan de ahí",
  "method.row.citiesByPlace.s": "Ciudades según la posición",
  "method.row.citiesByPlace.w": "modo Proyección",
  "method.row.conversion.d": "goles ÷ tiros (si ≥ 3 tiros)",
  "method.row.conversion.w": "ficha de jugador «Métricas»",
  "method.row.cornersFoulsEtc.d": "conteos brutos del partido",
  "method.row.cornersFoulsEtc.s": "Córners · Faltas · Fueras de juego · Tarjetas · Paradas",
  "method.row.defSolidity.d": "goles encajados ÷ xG rival (mismo cálculo, semántica invertida)",
  "method.row.deservedResult.d": "goles − xG: ≥ +0,8 «sobreactúa» · ≤ −0,8 «desperdicia» · si no «fiel»",
  "method.row.deservedResult.s": "Resultado merecido",
  "method.row.domination.d": "índice ponderado: xG·0,35 + posesión·0,25 + tiros·0,20 + a puerta·0,10 + córners·0,10 → cuota por lado (0–100)",
  "method.row.domination.w": "ficha de partido",
  "method.row.elo.d": "fuerza de un equipo. Rn = Ro + K·G·(W − We), K = 60 en la fase final; recalculado tras cada partido finalizado",
  "method.row.elo.s": "Elo (+ Δ)",
  "method.row.elo.w": "Clasificación Elo, ficha de país, tarjeta en vivo",
  "method.row.fifaRank.d": "clasificación mundial oficial (instantánea fijada, congelada durante el Mundial)",
  "method.row.fifaRank.s": "Clasificación FIFA",
  "method.row.fifaRank.w": "último criterio de desempate (interno)",
  "method.row.goalsAssists.d": "producción ofensiva",
  "method.row.goalsAssists.s": "Goles · asistencias",
  "method.row.groupStandings.d": "desempate FIFA Art. 13: enfrentamiento directo (pts/dif/goles) → dif. general → goles → fair-play → clasificación FIFA → sorteo con semilla. ⏱ si se incluye un marcador en vivo",
  "method.row.groupStandings.s": "Clasificaciones de grupo",
  "method.row.groupStandings.w": "cuadrícula de grupos",
  "method.row.h2h.d": "balance victorias-empates-derrotas + lista de enfrentamientos pasados",
  "method.row.h2h.s": "Cara a cara (H2H)",
  "method.row.idem.w": "ídem",
  "method.row.injuries.d": "bajas (actualizadas 1×/día)",
  "method.row.injuries.s": "Lesiones / ausencias",
  "method.row.injuries.w": "distintivo mini-campo, entrada del modelo",
  "method.row.lineups.d": "once inicial + formación (p. ej. 4-3-3) + entrenador",
  "method.row.lineups.w": "ficha de partido → mini-campo",
  "method.row.matchEvents.d": "goles, tarjetas y cambios con marca de tiempo (minuto + jugador)",
  "method.row.matchEvents.w": "ficha de partido «Sucesos» + flujo en vivo",
  "method.row.offEfficiency.d": "goles ÷ xG acumulado. Veredicto (sobre/subactúa) coloreado solo si el xG acumulado ≥ 3 (si no: varianza)",
  "method.row.passAcc.d": "% de pases completados en el partido",
  "method.row.passAcc.s": "Pases completados",
  "method.row.per90.d": "total ÷ minutos × 90",
  "method.row.per90.s": "G+A / 90 · Pases clave / 90 · Entradas / 90",
  "method.row.possession.d": "% del tiempo con el balón",
  "method.row.possession.s": "Posesión",
  "method.row.possession.w": "tarjeta en vivo + ficha de partido",
  "method.row.possibleOpponents.d": "distribución de los ocupantes del hueco rival en la simulación",
  "method.row.possibleOpponents.s": "Posibles rivales por ronda",
  "method.row.possibleOpponents.w": "modo Proyección (árbol)",
  "method.row.prediction.d": "probabilidad 1-X-2 (Elo → Poisson) + Elo + xG del modelo",
  "method.row.prediction.s": "Predicción previa al partido",
  "method.row.prediction.w": "tarjeta «próximo partido» (cursor), ficha de partido",
  "method.row.probabilities.d": "frecuencia sobre una simulación Monte-Carlo con semilla y condicionable",
  "method.row.probabilities.s": "Probabilidades (título / final / clasificación…)",
  "method.row.probabilities.w": "«Probabilidades», modo Proyección",
  "method.row.qualifConditions.d": "enumeración de todos los resultados V/E/D de los partidos restantes + regla de desempate (enfrentamiento directo, luego diferencia de goles)",
  "method.row.qualifConditions.s": "Condiciones de clasificación",
  "method.row.qualifConditions.w": "modal de Proyección",
  "method.row.ratesPct.d": "promedio / tasa de acierto",
  "method.row.ratesPct.s": "% pases · Duelos ganados % (≥5) · Regates % (≥3)",
  "method.row.rating.d": "nota de partido del proveedor (0–10)",
  "method.row.rating.w": "ficha de jugador «Partido a partido», cursor sobre el mini-campo",
  "method.row.scoreMinuteStatus.d": "resultado en vivo o final, minuto jugado (+ tiempo de descuento en vivo, p. ej. 90+4), estado (próximo / en vivo / descanso / finalizado)",
  "method.row.scoreMinuteStatus.s": "Marcador · minuto · estado",
  "method.row.scoreMinuteStatus.w": "franja Hoy, tarjeta En vivo, ficha de partido",
  "method.row.scorersAssists.d": "tops agregados del archivo",
  "method.row.scorersAssists.s": "Goleadores · Asistentes · Notas",
  "method.row.scorersAssists.w": "«Clasificaciones»",
  "method.row.shots.d": "tiros totales, tiros a puerta, tiros bloqueados",
  "method.row.shots.s": "Tiros · a puerta · bloqueados",
  "method.row.shotsPassesPct.d": "volumen y precisión",
  "method.row.shotsPassesPct.s": "Tiros / a puerta · pases / clave · % pases",
  "method.row.squadValue.d": "suma del valor de mercado del top-23 (actualizado 1×/día)",
  "method.row.squadValue.w": "ficha de país, clasificación Elo, modal de valor (detalle por jugador)",
  "method.row.tacklesDuels.d": "actividad defensiva y conducción",
  "method.row.tacklesDuels.s": "Entradas · duelos (ganados/total) · regates (logrados/intentados)",
  "method.row.teamEfficiency.d": "sobrerendimiento ofensivo (goles − xG) / defensivo (encajados − xGA). Solo equipos con xG ≥ 3; descriptivo, no una jerarquía de talento",
  "method.row.teamRating.d": "Σ(nota · minutos) ÷ Σ(minutos); tendencia = pendiente de las ~4 últimas notas (umbral ±0,15)",
  "method.row.teamRating.s": "Nota de equipo + tendencia ↗/↘",
  "method.row.teamRating.w": "distintivo de tarjeta en vivo, curva de ficha de país",
  "method.row.vsPositionAvg.d": "(valor del jugador ÷ promedio del torneo en su posición − 1) × 100. Entradas/90 = un volumen → mostrado pero sin color bueno/malo",
  "method.row.vsPositionAvg.w": "ídem (cuadrícula ordenada por posición)",
  "method.row.xg.d": "suma de las probabilidades de gol de las ocasiones (modelo del proveedor)",
  "method.row.xg.s": "xG (goles esperados)",
  "method.row.xgDiff.d": "Σ(xG creados − xG concedidos) — la medida más robusta con muestra pequeña",
  "method.row.yield.d": "rango Elo vs rango de valor; diferencia ≥ 4 puestos → juega «por encima / por debajo de su valor»",
  "method.row.yield.s": "Rendimiento",
  "method.sec.calcMatch.title": "Métricas calculadas — partido",
  "method.sec.calcPlayer.note": "Mostradas solo por encima de un volumen mínimo (indicado entre paréntesis); por debajo, ocultas.",
  "method.sec.calcPlayer.title": "Métricas calculadas — jugador (acumulado del torneo)",
  "method.sec.calcTeam.title": "Métricas calculadas — equipo (acumulado del torneo)",
  "method.sec.context.title": "Contexto de equipo y jugador",
  "method.sec.modelProjection.title": "Modelo y proyección",
  "method.sec.playerMatch.title": "Estadísticas de un jugador por partido",
  "method.sec.rawMatch.title": "Datos brutos de un partido",
  "method.sec.standings.title": "Clasificaciones del torneo",
  "method.sec.teamMatch.note": "Mostradas en barras local / visitante; al pasar el cursor, un gráfico de evolución en el tiempo.",
  "method.sec.teamMatch.title": "Estadísticas de equipo por partido",
  "method.standings": "Clasificaciones: reglamento FIFA 2026 (enfrentamientos directos primero); juego limpio no modelable desde los marcadores; último criterio: clasificación Elo y luego sorteo con semilla 🎲. Simulación Monte Carlo en un Web Worker, con semilla y reproducible.",
  "method.summary": "Metodología",
  "method.table.head.definition": "Definición",
  "method.table.head.source": "Fuente",
  "method.table.head.stat": "Estadística",
  "method.table.head.where": "Dónde",
  "method.title": "Método — cómo se calculan las estadísticas",
  "probs.metaBrowser": "navegador · {ms} ms",
  "probs.metaDraws": "{n} sorteos",
  "probs.metaSeed": "semilla {seed}",
  "probs.metaServer": "servidor (enviado)",
  "probs.modelTag": "modelo Elo–Poisson · Monte Carlo",
  "probs.preBelowThreshold": "< 0,3 % antes del torneo",
  "probs.preLabelBelow": "< 0,3 %",
  "probs.preTournamentTitle": "Antes del torneo: {pct} %",
  "probs.rowTitle": "{team} — antes del torneo {preLabel}",
  "probs.running": "Simulación en curso…",
  "probs.title": "Probabilidades de título",
  "probs.waiting": "Esperando la primera simulación…",
  "proj.champion": "Campeón {pct}",
  "proj.computingMc": "Calculando Monte Carlo…",
  "proj.cond.bestThird": " (mejor tercero)",
  "proj.cond.bothQualify": "si {team} y {opp} llegan hasta aquí",
  "proj.cond.dialogAria": "Condiciones del enfrentamiento",
  "proj.cond.if": "si {cond1} y {cond2}",
  "proj.cond.introDeep": "El trayecto y los marcadores posibles para que {team} y {opp} se crucen en {round}.",
  "proj.cond.introR32": "Todas las combinaciones de resultados por jugar que producen este partido de dieciseisavos.",
  "proj.cond.koNote": "Luego {team} y {opp} ganan cada uno sus rondas eliminatorias previas ({rounds}) para cruzarse en {round}.",
  "proj.cond.ofGroup": "del Grupo {group}",
  "proj.cond.tieNote": "En igualdad de puntos, el desempate del Mundial 2026 mira primero el enfrentamiento directo entre los equipos implicados, luego la diferencia de goles general y después los goles marcados — por eso el marcador de un partido puede cambiar la clasificación de otro equipo.",
  "proj.cond.title": "Condiciones — {team} vs {opp} · {round}",
  "proj.cta.continue": "Continuar",
  "proj.cta.editScores": "Editar mis marcadores",
  "proj.cta.nextRound": "Pasar a la siguiente ronda",
  "proj.cta.project": "Proyectar con mis marcadores",
  "proj.lessThan1pct": "< 1 %",
  "proj.line.conditionsTitle": "Condiciones para enfrentar a {opp}",
  "proj.match.awayScoreAria": "Marcador visitante",
  "proj.match.homeScoreAria": "Marcador local",
  "proj.match.liveTitle": "en directo",
  "proj.match.playedTitle": "partido jugado",
  "proj.modal.finish": "Terminar",
  "proj.modal.finishRound": "Terminar esta ronda",
  "proj.modal.hint": "Introduce los marcadores que imaginas: el trayecto y los porcentajes de tu equipo se recalculan al instante.",
  "proj.modal.reset": "Restablecer",
  "proj.modal.resetN": "Restablecer ({n})",
  "proj.modal.stepCount": "Ronda {i} / {n}",
  "proj.modal.tiebreakBody": " (Mundial 2026): 1) enfrentamiento directo — puntos, diferencia de goles, goles marcados; 2) diferencia de goles general; 3) goles marcados; 4) juego limpio (tarjetas); 5) clasificación FIFA.",
  "proj.modal.tiebreakTitle": "Desempate con igualdad de puntos",
  "proj.opening": "Abriendo la proyección…",
  "proj.outcome.awayWins": "{away} gana a {home}",
  "proj.outcome.draw": "{home}–{away}: empate",
  "proj.outcome.homeWins": "{home} gana a {away}",
  "proj.path.heading": "Trayecto probable",
  "proj.path.title": "Título",
  "proj.path.undetermined": "trayecto aún indeterminado",
  "proj.pending.decidedBy": "decidido por: {parts}",
  "proj.pending.group": "gr. {group}: {matches}",
  "proj.picker.label": "Proyectar",
  "proj.picker.model": "modelo Elo + valor",
  "proj.picker.recalc": "· recalculando…",
  "proj.place.1": "1.º",
  "proj.place.2": "2.º",
  "proj.place.3": "3.º",
  "proj.pos.bestThird": "mejor tercero",
  "proj.pos.heading": "Tus ciudades cambian según tu posición en el Grupo {group}",
  "proj.pos.variableSlot": "· franja variable",
  "proj.preparing": "Preparando…",
  "proj.qualFallback.head": "{team} clasificado del Grupo {group}",
  "proj.r32.whichResults": "¿Qué resultados hacen posible este partido de dieciseisavos?",
  "proj.round.final": "Final",
  "proj.round.qf": "Cuartos de final",
  "proj.round.r16": "Octavos de final",
  "proj.round.r32": "Dieciseisavos de final",
  "proj.round.sf": "Semifinales",
  "proj.short.qf": "Cuartos",
  "proj.short.r16": "8vos",
  "proj.short.r32": "16avos",
  "proj.short.sf": "Semis",
  "proj.solve.gdDeficit": "{rival} tiene {buts} de ventaja en diferencia de goles → {me} debe remontar ganando con mayor margen",
  "proj.solve.gdEqual": "{me} y {rival} tienen la misma diferencia de goles → quien gane con más margen termina por delante",
  "proj.solve.gdLead": "{me} ya tiene {buts} de ventaja en diferencia de goles sobre {rival} → se mantiene por delante conservándola",
  "proj.solve.goalOther": "{n} goles",
  "proj.solve.h2hDraw": "enfrentamiento directo empatado → se pasa a la diferencia de goles: {lead}",
  "proj.solve.h2hLoss": "{rival} ganó el enfrentamiento directo → {me} tendría que tomar ventaja de otra forma",
  "proj.solve.h2hWin": "{me} ganó el enfrentamiento directo → termina por delante de {rival} (1.º criterio de desempate, resuelto)",
  "proj.solve.head": "{team} {place} del Grupo {group}",
  "proj.solve.more": "+ {n} más",
  "proj.solve.none": "Ninguna combinación lo permite.",
  "proj.solve.settledNo": "✗ ya no es posible (grupo terminado)",
  "proj.solve.settledOk": "✓ ya asegurado (grupo terminado)",
  "proj.solve.tiedWith": "→ igualado a puntos con {rival}, {txt}",
  "proj.solve.tooMany": "Demasiados partidos por jugar para listar las combinaciones.",
  "proj.standings.gdTitle": "diferencia de goles",
  "proj.standings.gfTitle": "goles a favor",
  "proj.standings.playedTitle": "jugados",
  "proj.toggle.absences": "ausencias",
  "proj.toggle.absTitle": "Resta Elo según los ausentes (lesionados/sancionados). Experimental, limitado a ±{cap}.",
  "proj.toggle.exp": "exp.",
  "proj.toggle.form": "forma",
  "proj.toggle.formTitle": "Ajusta el Elo según la forma reciente (nota del equipo). Experimental, limitado a ±{cap}.",
  "proj.tree.heading": "Árbol del trayecto probable",
  "proj.tree.subhead": "Dieciseisavos en pestañas · las rondas siguientes siguen al rival elegido",
  "proj.tree.undetermined": "Trayecto aún indeterminado.",
  "proj.wizard.opponentIn": "Rival en {round}",
  "proj.wizard.yourPlacement": "La posición de tu equipo",
  "replay.groupPhaseDone": "Fase de grupos terminada",
  "replay.groupPhaseDoneToBracket": "Fase de grupos terminada — al cuadro",
  "replay.pauseAria": "Pausa",
  "replay.pauseResumeTitle": "Pausa / reanudar",
  "replay.resumeAria": "Reanudar",
  "replay.resuming": "Reproduciendo resultados…",
  "replay.skipToLive": "Ir al directo",
  "replay.speedTitle": "Acelerar",
  "replay.toBracket": "Ir al cuadro",
  "sim.championTitle": "Campeón del mundo 2026 (simulación)",
  "sim.footer.champion": "Campeón: {code}. Banderas: flag-icons (jsDelivr).",
  "sim.footer.deterministic": "escenario más probable, determinista",
  "sim.footer.model": "Modelo Elo–Poisson, {ratings}. No es un pronóstico garantizado.",
  "sim.footer.oneOfMany": "Una realización entre millones — {tail}",
  "sim.footer.relaunch": "vuelve a lanzar para otro sorteo",
  "sim.intro": "El modelo desarrolla un torneo completo — como un sorteo real. Elige el modelo, lánzalo y observa cómo surge el campeón.",
  "sim.label.fixedCount": "({n} fijados)",
  "sim.label.ratings": "Valoraciones: {value}",
  "sim.label.scenario": "Escenario: {value}",
  "sim.label.shootout": "Penaltis: {value}",
  "sim.label.startFrom": "Inicio: {value}",
  "sim.newDraw": "Nuevo sorteo",
  "sim.ratings.legacy": "Elo legacy",
  "sim.ratings.real": "Elo real",
  "sim.ratings.value": "Elo + valor",
  "sim.replay": "Repetir",
  "sim.replayScenario": "Repetir este escenario",
  "sim.runnerUp": "Finalista",
  "sim.scenario.modal": "Lo más probable",
  "sim.scenario.random": "Aleatorio",
  "sim.scenarioFr.modal": "lo más probable",
  "sim.scenarioFr.random": "aleatorio",
  "sim.seg.scenario": "Escenario",
  "sim.seg.startFrom": "Inicio",
  "sim.shootout.gk": "Porteros",
  "sim.startFr.fromReal": "desde lo real",
  "sim.startFr.scratch": "torneo completo",
  "sim.startFrom.fromReal": "Desde lo real",
  "sim.startFrom.scratch": "Torneo completo",
  "sim.tabFr.gk": "porteros",
  "sim.thirdPlace": "3.er puesto",
  "sim.title": "Simulación del torneo",
  "stats.col.apps.title": "partidos jugados (al menos un minuto)",
  "stats.col.assists.abbr": "A",
  "stats.col.assists.title": "asistencias (el último pase antes de un gol)",
  "stats.col.cards": "Tarjetas",
  "stats.col.cards.group.title": "total de tarjetas amarillas / rojas en el grupo",
  "stats.col.cards.match.title": "total de tarjetas del partido (amarillas + rojas)",
  "stats.col.cards.team.title": "total de tarjetas amarillas / rojas recibidas",
  "stats.col.corners.abbr": "Cor",
  "stats.col.corners.group.title": "total de córners obtenidos en el grupo",
  "stats.col.corners.team.title": "total de córners obtenidos",
  "stats.col.date": "Fecha",
  "stats.col.date.title": "fecha y hora del saque inicial (tu zona horaria)",
  "stats.col.diff.abbr": "Dif",
  "stats.col.diff.title": "diferencia de goles (marcados − encajados)",
  "stats.col.duelWinPct.abbr": "Duelos%",
  "stats.col.duelWinPct.title": "porcentaje de duelos ganados (al suelo y aéreos)",
  "stats.col.elo": "Elo",
  "stats.col.elo.title": "fuerza del equipo (World Football Elo), actualizada tras cada partido",
  "stats.col.goals": "Goles",
  "stats.col.goals.abbr": "G",
  "stats.col.goals.group.title": "total de goles marcados en el grupo",
  "stats.col.goals.match.title": "total de goles del partido (ambos equipos)",
  "stats.col.goals.player.title": "goles marcados",
  "stats.col.goalsAgainst.abbr": "GC",
  "stats.col.goalsAgainst.title": "goles en contra: goles encajados",
  "stats.col.goalsFor.abbr": "GF",
  "stats.col.goalsFor.title": "goles a favor: goles marcados",
  "stats.col.gpm.abbr": "G/p",
  "stats.col.gpm.title": "goles por partido (media) en el grupo",
  "stats.col.group": "Grupo",
  "stats.col.group.title": "grupo de la fase de grupos (✓ = sus 6 partidos terminaron). Clic = filtrar equipos",
  "stats.col.keyPasses.abbr": "PC",
  "stats.col.keyPasses.title": "pases clave: pases que llevan directamente a un tiro",
  "stats.col.match": "Partido",
  "stats.col.match.title": "clic = ficha del partido (alineaciones, hechos, estadísticas)",
  "stats.col.minutes.abbr": "Min",
  "stats.col.minutes.player.title": "minutos jugados en el torneo (acumulado)",
  "stats.col.minutes.team.title": "minutos jugados — 90/partido (120 con prórroga) + tiempo añadido: status.extra en directo, si no estimados sumando el tiempo añadido de cada periodo según los eventos (la fuente no da el total)",
  "stats.col.passPct.abbr": "Pase%",
  "stats.col.passPct.match.title": "% de pases completados de cada equipo, en el orden del partido (equipo izquierdo – equipo derecho)",
  "stats.col.passPct.player.title": "% de pases completados seguido del NÚMERO total de pases intentados sobre el que se calcula — ej. 90%/230 (un % sobre pocos pases es poco significativo)",
  "stats.col.passPct.team.title": "% de pases completados del equipo (agregado de todos sus jugadores) seguido del NÚMERO total de pases intentados sobre el que se calcula — ej. 86%/4200; alimentado en producción",
  "stats.col.played.abbr": "PJ",
  "stats.col.played.group.title": "partidos jugados de los 6 del grupo",
  "stats.col.played.team.title": "partidos jugados",
  "stats.col.player.title": "clic = ficha del jugador (estadísticas del torneo, curva de notas)",
  "stats.col.points.abbr": "Pts",
  "stats.col.points.title": "puntos en la fase de grupos (victoria 3, empate 1, derrota 0)",
  "stats.col.pos": "Posición",
  "stats.col.pos.title": "posición: Portero / Def(ensa) / Cent(rocampista) / Del(antero)",
  "stats.col.poss.abbr": "Pos",
  "stats.col.poss.match.title": "posesión del balón (%) de cada equipo, en el orden del partido",
  "stats.col.possession.abbr": "Pos%",
  "stats.col.possession.title": "posesión media del balón (% del tiempo de juego)",
  "stats.col.rating": "Nota",
  "stats.col.rating.title": "nota media del jugador en el torneo (0–10, proveedor)",
  "stats.col.shots": "Tiros",
  "stats.col.shots.group.title": "total de tiros intentados en el grupo",
  "stats.col.shots.match.title": "tiros a puerta / total de tiros de cada equipo, en el orden del partido (ej. 5/12–2/8)",
  "stats.col.shots.player.title": "tiros a puerta / total de tiros intentados en el torneo (ej. 5/12)",
  "stats.col.shots.team.title": "tiros a puerta / total de tiros intentados (ej. 42/118)",
  "stats.col.stage": "Ronda",
  "stats.col.stage.title": "ronda de la competición (fase de grupos o eliminatorias)",
  "stats.col.team": "Equipo",
  "stats.col.team.title": "clic = ficha del país (plantilla, resultados, Elo, valor)",
  "stats.col.xg.group.title": "goles esperados acumulados: calidad total de las ocasiones creadas (modelo del proveedor)",
  "stats.col.xg.match.title": "goles esperados (xG) de cada equipo, en el orden del partido — quién merecía marcar frente al resultado",
  "stats.col.xg.team.title": "goles esperados creados: calidad acumulada de las ocasiones del equipo (modelo del proveedor)",
  "stats.col.xga.title": "goles esperados concedidos: calidad de las ocasiones cedidas al rival",
  "stats.col.xgaHead": "xGA",
  "stats.col.xgHead": "xG",
  "stats.empty.waiting": "Esperando los datos…",
  "stats.filter.allGroups": "Todos los grupos",
  "stats.filter.allStages": "Todas las rondas",
  "stats.filter.byGroup.aria": "Filtrar por grupo",
  "stats.filter.byStage.aria": "Filtrar por ronda",
  "stats.filter.group.option": "Grupo {g}",
  "stats.filter.groupStage": "Fase de grupos",
  "stats.footer.method.link": "Método",
  "stats.footer.note": "Grupos, equipos y partidos: agregados en directo desde el flujo (marcador en curso incluido, ⏱). Jugadores: agregado del servidor, actualizado periódicamente. Definiciones: pestaña Método.",
  "stats.footerNote": "Grupos, equipos y partidos: agregados en directo desde el flujo (marcador en curso incluido, ⏱). Jugadores: agregado del servidor, refrescado periódicamente. Definiciones: ",
  "stats.graph.ariaLabel": "Evolución de {label} a lo largo del partido",
  "stats.graph.buildingSub": "una lectura cada ~30 s — aparece en un instante",
  "stats.graph.buildingTitle": "Curva en construcción",
  "stats.graph.unavailableSub": "partido ya finalizado al iniciar el seguimiento — sin historial retroactivo",
  "stats.graph.unavailableTitle": "Evolución no disponible",
  "stats.group.cell": "Grupo {group}",
  "stats.group.done.title": "grupo terminado",
  "stats.group.row.title": "Filtrar los equipos del grupo {group}",
  "stats.live.title": "partido en curso",
  "stats.liveNow": "{n} en directo ⏱",
  "stats.metric.conversion": "Conversión",
  "stats.metric.dribblePct": "Regates completados",
  "stats.metric.duelWinPct": "Duelos ganados",
  "stats.metric.gaPer90": "G+A / 90",
  "stats.metric.keyPassesPer90": "Pases clave / 90",
  "stats.metric.passAcc": "% de pases",
  "stats.metric.tacklesPer90": "Entradas / 90",
  "stats.pill.corners": "córners",
  "stats.pill.goalsPerMatch": "goles / partido",
  "stats.pill.redCards": "tarjetas rojas",
  "stats.pill.shots": "tiros",
  "stats.pill.xgTotal": "xG total",
  "stats.pill.yellowCards": "tarjetas amarillas",
  "stats.players.empty": "Clasificaciones de jugadores no disponibles aquí (alimentadas por el archivo en producción, en el próximo agregado).",
  "stats.search.placeholder": "Buscar un jugador…",
  "stats.section.groups": "Grupos",
  "stats.section.groups.hint": "clic en un grupo → filtra los equipos",
  "stats.section.matches": "Partidos",
  "stats.section.players": "Jugadores",
  "stats.section.teams": "Equipos",
  "stats.shotsOnAbbr": "a puerta",
  "stats.stage.group": "Grupo · J{md}",
  "stats.statMeta.blocked": "Tiros bloqueados",
  "stats.statMeta.corners": "Córners",
  "stats.statMeta.fouls": "Faltas",
  "stats.statMeta.offsides": "Fueras de juego",
  "stats.statMeta.red": "Tarjetas rojas",
  "stats.statMeta.saves": "Paradas",
  "stats.statMeta.shotsOnTarget": "Tiros a puerta",
  "stats.statMeta.xg": "Goles esperados (xG)",
  "stats.statMeta.yellow": "Tarjetas amarillas",
  "stats.title": "Estadísticas de la Copa del Mundo",
  "teff.caveat": "Nota: la diferencia con los xG sigue siendo sensible al azar con pocos partidos — no es una jerarquía de talento.",
  "teff.col.attack": "Sobrerrendimiento ofensivo",
  "teff.col.defense": "Sobrerrendimiento defensivo",
  "teff.main.conceded": "{n} enc.",
  "teff.main.goals": "{n} gol",
  "teff.section.count": "goles vs xG en el torneo",
  "teff.section.title": "Eficacia de los equipos",
  "thirds.col.goalDiff": "±",
  "thirds.col.group": "Gr.",
  "thirds.criteria": "Criterios: puntos, diferencia de goles, goles marcados, clasificación FIFA, sorteo 🎲.",
  "thirds.liveNote": "marcador en juego incluido (provisional).",
  "thirds.subtitle": "clasificados a los dieciseisavos",
  "thirds.title": "Los 8 mejores terceros",
  "stats.ev.inMatch": "Evolución minuto a minuto",
  "stats.ev.perMatch": "Partido a partido del torneo",
  "stats.ev.perNation": "Repartido por selección y jornada",
  "stats.ev.noData": "Sin datos para esta estadística.",
  "stats.ev.cellHint": "Ver la evolución",
};

export default es;
